import type { TIeSubject } from '@/components/App/Leasing/types';

const DUPLICATE_SUBJECT_MESSAGE =
  'Авто с такой маркой, моделью, годом и двигателем уже добавлено';

export const parseAmount = (value?: string | null): number =>
  Number(String(value ?? '').replace(/\D/g, '')) || 0;

export const getCarLabel = (product?: Partial<TIeSubject> | null): string =>
  [
    product?.brandName,
    product?.modelName,
    product?.equipmentName,
    product?.year
  ]
    .filter(Boolean)
    .join(', ');

export const getSubjectCombinationKey = (
  product?: Partial<TIeSubject> | null
): string => {
  if (
    !product?.brandCode ||
    !product.modelCode ||
    !product.year ||
    !product.engineType
  )
    return '';

  return `${product.brandCode}|${product.modelCode}|${product.year}|${product.engineType}`;
};

export const getSubjectDuplicateError = (
  products: Array<Partial<TIeSubject> | undefined>,
  index: number
): string | true => {
  const key = getSubjectCombinationKey(products[index]);
  if (!key) return true;

  const hasDuplicate = products.some(
    (product, productIndex) =>
      productIndex !== index && getSubjectCombinationKey(product) === key
  );

  return hasDuplicate ? DUPLICATE_SUBJECT_MESSAGE : true;
};

export const getSubjectsTotal = (
  products: Array<Partial<TIeSubject> | undefined> = []
): number =>
  products.reduce((sum, product) => {
    const count = Number(product?.count) || 0;
    if (count < 1) return sum;

    return sum + parseAmount(product?.cost) * count;
  }, 0);

// Сумма лизинга = стоимость всех авто минус первоначальный взнос.
export const getLeasingAmount = (
  products: Array<Partial<TIeSubject> | undefined> = [],
  initialPayment?: string | null
): number =>
  Math.max(getSubjectsTotal(products) - parseAmount(initialPayment), 0);
